import { Component } from '@angular/core';

@Component({
    selector: 'abq-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent {

    constructor() {
    }

    ngOnInit(): void {
    }

}
